(function (angular) {
  class CCPaymentButtonCtrl {
    constructor($timeout) {
      'ngInject';

      angular.extend(this, {
        $timeout
      });
      this.numQuickClicks = 0;
    }

    disableButton() {
      return !this.formValid || this.paymentInProcess;
    }

    buttonClick() {
      const this2 = this;
      this.numQuickClicks = this.numQuickClicks + 1;
      console.log("Click Number: " + this.numQuickClicks);

      if (this.numQuickClicks === 1) {
        this.$timeout(() => {
          this2.numQuickClicks = 0;
        }, 1000);
        this.onClick();
      } else {
        this.$timeout(() => {
          this2.numQuickClicks = 0;
        }, 1000);
      }
    }

  }

  CCPaymentButtonCtrl.$inject = ["$timeout"];
  angular.module('pims').component('paymentButton', {
    template: `
      <div class="payment-button-holder">

        <button loading-when="$ctrl.paymentInProcess" ng-disabled="$ctrl.disableButton()" type="submit" class="btn btn-success payment-button" ng-click="$ctrl.buttonClick()">
           {{ 'Save new card as default' }}
        </button>

      </div>
    `,
    controller: CCPaymentButtonCtrl,
    bindings: {
      formValid: '<',
      paymentInProcess: '<',
      onClick: '&'
    }
  });
})(angular);